import React from 'react';
import { Link } from 'react-router-dom';
import { Container, SectionHeader, Button } from '../ui';
import { DISTRICTS } from '../../data/districts';

// Showcase strip that pulls real district configs and links into the /demo system.
const DistrictShowcase = () => {
  const featured = DISTRICTS.slice(0, 8);

  return (
    <section id="districts" className="bg-white py-16 sm:py-24 scroll-mt-16">
      <Container>
        <SectionHeader
          eyebrow="District demos"
          title="Preview Valley Tickets for your district"
          subtitle="Built to show what Valley Tickets could look like for your school district — a sample portal with that district's branding, schools, and example events. Tap any to explore."
          action={<Button to="/demo" variant="outline" size="sm" className="hidden sm:inline-flex">View all districts →</Button>}
        />

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mt-8">
          {featured.map((d) => {
            const { primary, secondary, accent } = d.colors;
            const initials = d.shortName ? d.shortName.slice(0, 4) : d.name.slice(0, 2).toUpperCase();
            return (
              <Link
                key={d.slug}
                to={`/demo/${d.slug}`}
                className="group rounded-2xl overflow-hidden shadow-card hover:shadow-lift transition-all hover:-translate-y-0.5 border border-ink-100"
              >
                <div
                  className="h-20 flex items-center justify-center relative"
                  style={{ background: `linear-gradient(135deg, ${primary} 0%, ${secondary} 100%)` }}
                >
                  <div
                    className="w-11 h-11 rounded-xl flex items-center justify-center font-extrabold text-sm shadow ring-2 ring-white/25"
                    style={{ backgroundColor: accent, color: primary }}
                  >
                    {d.logo ? <img src={d.logo} alt="" className="w-full h-full object-contain rounded-xl p-1" /> : initials}
                  </div>
                </div>
                <div className="p-3 bg-white">
                  <p className="font-semibold text-ink-900 text-sm truncate group-hover:text-brand-700 transition-colors">{d.name}</p>
                  <p className="text-xs text-ink-400 truncate">{d.city}</p>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Button to="/demo" variant="outline" size="md">View all {DISTRICTS.length} districts →</Button>
        </div>
      </Container>
    </section>
  );
};

export default DistrictShowcase;
